import { UserStatus } from '@portal/entity-services/interfaces';
import { IOrganisation } from '../../organisations/interfaces/organisation.interface';
import { INameDetails } from './name-details.interface';
import { UserRole } from '../enums/user-role.enum';
import { Application } from '@portal/shared/auth/authorization/src/lib/enums/application.enum';
import { Locale } from '@portal/shared/languages';
import { ITermsAndConditions } from './terms-and-conditions.interface';

export interface IUser {
  // API fields
  userUid: string;
  name: string;
  nameDetails?: INameDetails;
  roles: UserRole[];
  email: string;
  status: UserStatus;
  createdDate?: string;
  modifiedDate?: string;
  version?: number;
  entityUid?: string;
  entity?: IOrganisation;
  language?: Locale;
  mobilePhoneNumber?: number;

  // derived fields
  isAuthenticated?: boolean;
  locale?: string;
  defaultApplication?: Application;
  notificationUpdateStatus?: boolean;
  termsAndConditions?: ITermsAndConditions;
  marketingTermsAndConditions?: ITermsAndConditions | boolean;
}
